export enum COOKIE_KEY {
  TOKEN = 'hzc_token',
  DEVICE_ID = 'hzc_device_id',
  IS_ANONYMOUS = 'hzc_is_anonymous',
  REFERRER_ID = 'hzc_referrer_id',
  PREFERRAL_CODES = 'hzc_preferral_codes',
  AB = 'hzc_ab',
}

/** Next.js / Set-Cookie `maxAge` is seconds (not milliseconds). ~25 years. */
export const COOKIE_MAX_AGE_SECONDS = 25 * 365 * 24 * 60 * 60;

/**
 * Shared browser-cookie defaults.
 *
 * Keep these cookies readable by the browser: the existing client API
 * flow reads the encrypted token and sends it as a request header. Moving the
 * token to HttpOnly requires a separate BFF/session migration.
 *
 * Public HTML no longer Set-Cookie; anonymous session is created in the
 * browser against callback (`/user/init`), then written with document.cookie.
 */
export const COOKIE_OPTIONS = {
  path: '/',
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'lax' as const,
  maxAge: COOKIE_MAX_AGE_SECONDS,
};

export enum ORDER_STATUS {
  PAYMENT_PENDING = 30,
  PAYMENT_DONE = 40,
  NEW_PRINTING = 48,
  PREPARING = 50,
  PRINTED = 60,
  ON_THE_COUNTER = 70,
  ASSIGNED_TO_COURIER = 80,
  SHIPPED = 85,
  ON_DELIVERY = 90,
  DELIVERED = 100,
  SYSTEM_CANCELLED = 120,
  CUSTOMER_CANCELLED = 130,
  CUSTOMER_OVERRIDE = 140,
  CUSTOMER_RETURNED = 150,
  WAREHOUSE_CANCELLED = 160,
  ADMIN_CANCELLED = 170,
}

export enum SETTINGS_TYPE {
  MAIN_CATEGORIES = 'main-categories',
  FOOTER_CATEGORIES = 'footer-categories',
  LOCATIONS = 'locations',
  TOP_BAR = 'topbar',
}

/** `unstable_cache` / `revalidateTag` — `/api/revalidate?type=all` ile tüm data cache temizlenir */
export const REVALIDATE_TAG_ALL = 'hzc:revalidate-all';

export enum CACHE_KEY {
  HOMEPAGE = 'home-page',
  FOOTER = 'footer',
  SETTINGS = 'settings',
  PRODUCT_LIST = 'product-list',
  PRODUCT_SEARCH = 'product-search',
  MAIN_CATEGORY = 'main-category',
  BLOG_LIST = 'blog-list',
  MAIN_CATEGORIES = 'main-categories',
  LOCATIONS = 'locations',
  FILTERS = 'filters',
  MENU_CATEGORIES = 'menu-categories',
  FOOTER_CATEGORIES = 'footer-categories',
  TOP_BAR = 'top-bar',
}

export enum HTTP_REQUEST {
  GET = 'GET',
  POST = 'POST',
}

export const IMAGE_PLACEHOLDER = '/hizli-cicek-resmi-.png';

export const defaultMetaData = {
  title: {
    template: '%s - Hızlı Çiçek',
    default: 'Hızlı Çiçek',
  },
  description: '30 dakika içerisinde çiçek kapında',
  image: 'https://cdn.hizlicicek.com/public/logo_square.png',
  siteName: 'Hızlı Çiçek',
  url: 'https://hizlicicek.com',
  alt: 'Hızlı Çiçek',
  author: 'Hızlı Çiçek',
  brand: 'Hızlı Çiçek',
  keywords: ['çiçek', 'çiçek siparişi', 'online çiçek', 'istanbul çiçek', 'çiçek gönder'],
  logo: 'https://hizlicicek.com/ic_hzc_purple.png',
  locale: 'tr_TR',
};

/** Sepet / sipariş teslim kanalı (order servisi ile uyumlu) */
export enum DELIVERY_TYPE {
  COURIER = 10,
  CARGO = 20,
  DECORATION = 30,
}

export enum PERMALINK_CONTENT_TYPE {
  PRODUCT = 2,
  CATEGORY = 3,
  CITY = 4,
  DISTRICT = 5,
  SPECIAL_DAY = 6,
  SEO = 7,
  CONTENT = 8,
  CARD_MESSAGE = 9,
  HOMEPAGE = 10,
  BLOG = 11,
  TOWN = 12,
  CAMPAIGN = 13,
  MAIN_CATEGORY = 14,
  LANDING_PAGE = 17,
  CHANNEL_LANDING_PAGE = 18,
}

export enum HELP_BUTTON_ID {
  WHATSAPP = 2,
  CHATBOT = 3,
}
